import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { SIZE_CHART } from "../../data/collection";
import { EASE } from "./Reveal";

export default function SizeGuide({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="size-guide-modal"
          className="fixed inset-0 z-[130] flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
        >
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
          <motion.div
            initial={{ y: 24, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 24, opacity: 0 }}
            transition={{ duration: 0.35, ease: EASE }}
            className="relative w-full max-w-md border border-black/10 bg-white text-[#050505]"
          >
            <div className="flex items-center justify-between border-b border-black/10 px-6 py-4">
              <div>
                <p className="font-body text-[10px] uppercase tracking-[0.3em] text-black/40">
                  Size Guide
                </p>
                <h3 className="mt-1 font-display text-xl font-light">Measurements (inches)</h3>
              </div>
              <button
                data-testid="size-guide-close"
                onClick={onClose}
                className="flex h-9 w-9 items-center justify-center rounded-full border border-black/15 text-black/60 transition-colors hover:bg-black hover:text-white"
              >
                <X className="h-4 w-4" strokeWidth={1.3} />
              </button>
            </div>

            <div className="px-6 py-5">
              <table className="w-full border-collapse" data-testid="size-guide-table">
                <thead>
                  <tr className="bg-[#050505] text-white">
                    {SIZE_CHART.headers.map((h) => (
                      <th
                        key={h}
                        className="px-3 py-2.5 text-left font-body text-[10px] uppercase tracking-[0.18em] font-medium"
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {SIZE_CHART.rows.map((row, i) => (
                    <tr key={row[0]} className={i % 2 ? "bg-[#FDFBF7]" : "bg-white"}>
                      {row.map((cell, j) => (
                        <td
                          key={j}
                          className={`px-3 py-2.5 border-t border-black/10 text-sm ${
                            j === 0 ? "font-display tracking-wide" : "font-body font-light text-black/70"
                          }`}
                        >
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <p className="mt-4 font-serif-editorial text-sm italic text-black/50">
                Every piece can also be tailored to your own measure — just share your details in the DM.
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
